export interface BaseField {
  fieldName: string;
  isBadge: boolean;
  isSubField: boolean;
}

export interface SimpleField extends BaseField {
  fieldLink: string;
  badgeCount?: number;
  isSubField: false;
}

export interface SubField {
  subFieldName: string;
  subFieldLink: string;
}

export interface DropdownField extends BaseField {
  subFieldList: SubField[];
  isSubField: true;
}

export type SidebarField = SimpleField | DropdownField;

const makeField = (
  fieldName: string,
  fieldLink: string,
  isBadge = false,
): SimpleField => ({
  fieldName,
  fieldLink,
  isBadge,
  isSubField: false,
});

const profile = makeField("Profile", "/dashboard/profile");
const uploadCase = makeField("Upload Case", "/dashboard/upload");
const adminCases = makeField("Admin Cases", "/dashboard/admin/cases");
const redesigns = makeField("Redesigns", "/dashboard/admin/redesigns");
const mistakes = makeField("Mistakes", "/dashboard/admin/mistakes");
const labDetails = makeField("Lab Details", "/dashboard/admin/labdetails");
const caseOk = makeField("Case Ok", "/dashboard/admin/caseok");
const designReady = makeField("Design Ready", "/dashboard/admin/designready");
const generateInvoices = makeField(
  "Generate Invoices",
  "/dashboard/admin/generate/invoices",
);
const labPricing = makeField(
  "Lab Pricing",
  "/dashboard/admin/lab-pricing",
);
const adminInvoices = makeField("Admin Invoices", "/dashboard/admin/invoices");
const Testimonials = makeField(
  "Testimonials",
  "/dashboard/admin/all/testimonials",
);
const units = makeField("Units", "/dashboard/admin/units");
const fzUnits = makeField("FZ Units", "/dashboard/admin/units/fz");
const unitsLedger = makeField("Units Ledger", "/dashboard/admin/units/ledger");
const markedUnits = makeField("Marked Units", "/dashboard/admin/marked-units");

const dataExports = makeField(
  "Export Data",
  "/dashboard/admin/data/export",
);

const localDownloader = makeField(
  "Local Downloader",
  "/dashboard/admin/local-downloader",
);

export const caseLifecycleReport = makeField(
  "Case Report",
  "/dashboard/admin/data/case-report",
);

const occlusionContact = makeField(
  "Occlusion Contact",
  "/dashboard/occlusion-contact",
);
const requests = makeField("Requests", "/dashboard/admin/requests");
const loginAs = makeField("Login as", "/dashboard/admin/impersonation");
const roles = makeField("Roles", "/dashboard/admin/roles");
export const photoRecolour = makeField(
  "Photo Recolour",
  "/dashboard/photo-recolour",
);
const photoRecolourPackages = makeField(
  "Recolour Packages",
  "/dashboard/admin/photo-recolour-packages",
);
const photoRecolourCredits = makeField(
  "Recolour Credits",
  "/dashboard/photo-recolour/packages",
);
const photoRecolourOrders = makeField(
  "Order History",
  "/dashboard/photo-recolour/order-history",
);

const surgerySlots = makeField(
  "Surgery Slots",
  "/dashboard/admin/surgery-slots",
);
const bookSurgery = makeField("Book Live Surgery", "/dashboard/book-surgery");

const HoldCases = makeField("Hold-Cases", "/dashboard/hold-cases");
const ReadyToUpload = makeField(
  "Ready to Upload",
  "/dashboard/admin/ready-to-upload",
);

const myCasesUser = makeField("My Cases", "/dashboard/my-cases");
const myCasesAdmin = makeField("My Cases", "/dashboard/admin/my-cases");

const Invoices = makeField("Invoices", "/dashboard/my-invoices");

export const adminFields: SidebarField[] = [
  profile,
  uploadCase,
  adminCases,
  redesigns,
  mistakes,
  myCasesAdmin,
  HoldCases,
  ReadyToUpload,
  surgerySlots,
  labDetails,
  caseOk,
  designReady,
  units,
  fzUnits,
  unitsLedger,
  dataExports,
  markedUnits,
];

export { labPricing };

export const userFields: SidebarField[] = [
  profile,
  uploadCase,
  myCasesUser,
  Invoices,
  bookSurgery,
  photoRecolour,
  photoRecolourCredits,
  photoRecolourOrders,
];

export const superAdminFields: SidebarField[] = [
  profile,
  loginAs,
  requests,
  roles,
  photoRecolour,
  photoRecolourPackages,
  photoRecolourOrders,
  uploadCase,
  adminCases,
  redesigns,
  mistakes,
  myCasesAdmin,
  HoldCases,
  ReadyToUpload,
  surgerySlots,
  labDetails,
  caseOk,
  designReady,
  units,
  fzUnits,
  unitsLedger,
  markedUnits,
  generateInvoices,
  labPricing,
  adminInvoices,
  Invoices,
  Testimonials,
  dataExports,
  caseLifecycleReport,
  localDownloader,
  occlusionContact,
];

export const sideAdminFields: SidebarField[] = [
  profile,
  uploadCase,
  adminCases,
  myCasesAdmin,
  labDetails,
  Invoices,
];

export const CRMFields: SidebarField[] = [
  profile,
  uploadCase,
  adminCases,
  redesigns,
  myCasesAdmin,
  HoldCases,
  ReadyToUpload,
  surgerySlots,
  labDetails,
  caseOk,
  designReady,
];

export const designerFields: SidebarField[] = [
  profile,
  adminCases,
  redesigns,
  myCasesAdmin,
  HoldCases,
  ReadyToUpload,
  surgerySlots,
  labDetails,
];

export const adminReadFields: SidebarField[] = [
  profile,
  requests,
  uploadCase,
  adminCases,
  redesigns,
  myCasesAdmin,
  labDetails,
  adminInvoices,
  Invoices,
  Testimonials,
];
